import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { style: { "position": "sticky", "z-index": "2", "top": "0" } };
const _hoisted_2 = { class: "mobileSidebarMyAccountMenu" };
const _hoisted_3 = { class: "col-12 bg-brand_beige_hover py-2" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-10" };
const _hoisted_6 = { class: "text-left strong font4 m-0 mb-n1 pb-0" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
    key: 0,
    class: "col-12 py-2"
};
import eventBus from '@/services/EventBus';
import { ref, onMounted, computed } from 'vue';
import { useStore } from '@/store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MobileSidebarMyAccountMenu',
    setup(__props) {
        const store = useStore();
        const firstName = computed(() => { var _a; return (_a = store.state.account.currentUser) === null || _a === void 0 ? void 0 : _a.firstName; });
        const isAdmin = computed(() => { var _a; return (_a = store.state.account.currentUser) === null || _a === void 0 ? void 0 : _a.is_admin; });
        onMounted(() => {
            eventBus.on('openMobileSidebarMyAccountMenu', openMenuAndDoThings);
            eventBus.on('closeMobileSidebarMyAccountMenu', closeMenu);
        });
        const openMenu = ref(false);
        const openMenuAndDoThings = () => {
            openMenu.value = true;
        };
        const closeMenu = () => {
            openMenu.value = false;
        };
        return (_ctx, _cache) => {
            const _component_my_account_menu_items = _resolveComponent("my-account-menu-items");
                                                                  
                                                                      
            return (_openBlock(), _createBlock(_component_v_dialog, {
                fullscreen: "",
                transition: "dialog-top-transition",
                persistent: false,
                class: "mobileMenu",
                modelValue: openMenu.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((openMenu).value = $event)),
                width: "480px",
                "max-width": "96vw",
                height: "100vh"
            }, {
                default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createElementVNode("nav", _hoisted_1, [
                                _createElementVNode("ul", _hoisted_2, [
                                    _createElementVNode("li", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("h2", _hoisted_6, [
                                                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-brand_user ml-n2" }, null, -1)),
                                                    _createTextVNode(" Moin " + _toDisplayString(firstName.value), 1)
                                                ]),
                                                _createElementVNode("strong", {
                                                    class: "text-underline font8",
                                                    onClick: _cache[0] || (_cache[0] = ($event) => (openMenu.value = false))
                                                }, " Zurück zum Hauptmenü ")
                                            ]),
                                            _createElementVNode("div", {
                                                onClick: ($event) => (isActive.value = false),
                                                class: "col-2 d-flex align-items-center justify-content-end pl-1"
                                            }, [...(_cache[3] || (_cache[3] = [
                                                    _createElementVNode("i", { class: "icon-cancel pointerhover" }, null, -1)
                                                ]))], 8, _hoisted_7)
                                        ])
                                    ]),
                                    (isAdmin.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                                                _createElementVNode("a", {
                                                    class: "row",
                                                    href: "/admin",
                                                    title: "Shop-Admin Bereich"
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "col-10 p-0 text-left",
                                                        style: { "hyphens": "auto" }
                                                    }, [
                                                        _createElementVNode("span", { class: "fc-darkRed font-weight-bold" }, "SHOP ADMIN")
                                                    ])
                                                ], -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_my_account_menu_items)
                                ])
                            ])
                        ]),
                        _: 2
                    }, 1024)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});


/* Vuetify */
import { VCard as _component_v_card } from "vuetify/components/VCard"
import { VDialog as _component_v_dialog } from "vuetify/components/VDialog"

